import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MantineProvider } from '@mantine/core'
import { AdminAuthProvider } from './auth/AdminAuthProvider'
import App from './App'
import { theme } from '@racedash/shared/mantine'
// Order matters. Mantine's stylesheet must land before ours so the handful of
// things we still style ourselves win, and tokens.css before both since both
// read from it.
import '@racedash/shared/tokens.css'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('No #root element')

createRoot(root).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <AdminAuthProvider>
        <App />
      </AdminAuthProvider>
    </MantineProvider>
  </StrictMode>,
)
